import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _PayrollAccountant, _PayrollFactor } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { PayrollTypeSelect } from "./PayrollTypeSelect";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { ValueTypeSelector } from "../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { FortnightTypeConstants } from "./FortnightTypeConstants";


export const PayrollFactor = () => {

    const PayrollFactor = useDataBean(_PayrollFactor);
    const PayrollAccountant = useDataBean(_PayrollAccountant);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [Payroll, setPayroll] = useState<number>(null)
    const [valueclass, setValueclass] = useState<number>(null)
    const [fornight, setFornight] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [Payroll])

    const getLista = () => {

        PayrollFactor.instance.getPayrollFactorCatalogByPayrollType(Payroll, valueclass, fornight).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)

                }
            }
        )

    }

    const create = () => {
        PayrollFactor.setBean({
            IDPayrollType: Payroll
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        PayrollAccountant.instance.updatePayrollBudgetAccountant(PayrollFactor.bean).then(
            (resp: any) => {
                if (resp) {

                    getLista();
                    setModal({ ...modal, "view": false });

                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDPayrollFactor', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Nombre Concepto', property: 'Name', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Tipo Factor', property: 'FortnightTypeName', visible: true },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Cuenta Contable', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'FactorBudgetIDStrName', visible: true },
    ]


    const listaBotones = () => {
        const botones = [
            { titulo: 'Configurar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Configurar ${PayrollFactor.bean.Name}`, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Configuración Contable-Presupuestal de Tipos de Payroll">
            <div className="row">
                <div className="col-md-4">
                    <PayrollTypeSelect idSelector={Payroll} onChange={(e) => { setPayroll(e) }} />
                </div>
                <div className="col-md-4">
                    <ValueTypeSelector label="Clase de Concepto" idSelector={valueclass} onChange={(e) => { setValueclass(e) }} />
                </div>
                <div className="col-md-4">
                    <FortnightTypeConstants idSelector={fornight} onChange={(e) => { setFornight(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">

                    <BasicButton icon="" eventClick={getLista} disable={!Payroll}>Buscar</BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PayrollFactor.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Contable" jsonCode={PayrollFactor.bean.ExpensiveAccountantIDStr} onChange={(e) => { console.log(e); PayrollFactor.setBean({ ...PayrollFactor.bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID label="Rubro Presupuestal" jsonCode={PayrollFactor.bean.FactorBudgetIDStr} onChange={(e) => { PayrollFactor.setBean({ ...PayrollFactor.bean, "FactorBudgetIDStr": e.JsonCode }) }} edit={false} />
                            </div>
                            {/* . */}
                            {/* <PrintJson json={PayrollFactor.bean} /> */}
                        </div>
                    </Modal>

                </div>

            </div>
        </BasicPage>
    )
}